import React from "react";
import { Controller } from "react-hook-form";

function SelectField(props) {
  const {
    label,
    id,
    extra,
    options = [],
    state,
    disabled,
    value,
    onChange,
    control,
    name,
    rules,
    className = "",
    ...rest
  } = props;

  const renderSelect = ({ field = {}, error } = {}) => {
    const selectId = id || name;
    const selectState = error ? "error" : state;

    return (
      <div className={`${extra}`}>
        {label && (
          <label
            htmlFor={selectId}
            className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            {label}
          </label>
        )}
        <select
          {...rest}
          {...field}
          id={selectId}
          disabled={disabled}
          value={field.value ?? value ?? ""}
          onChange={field.onChange || onChange}
          className={`rounded-xl border border-solid p-3 py-2.5 ${
            disabled
              ? "border-none bg-gray-100"
              : selectState === "error"
              ? "border-red-500 text-red-500"
              : "border-gray-200"
          } ${className}`}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {error?.message && <p className="mt-1 text-sm text-red-600">{error.message}</p>}
      </div>
    );
  };

  if (control && name) {
    return (
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => renderSelect({ field, error: fieldState.error })}
      />
    );
  }

  return renderSelect();
}

export default SelectField;
